import { Schedule } from '@mui/icons-material';
import { Badge } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { AXLE_TEAL, HIGH_PRIORITY_COLOR } from '../../constants/colors';
import { useScheduleChangeRequestCounts } from '../scheduleRequests/useScheduleChangeRequestCounts';

export const ScheduleIcon = React.forwardRef<SVGSVGElement>(function ScheduleIcon(props, ref) {
    const location = useLocation();
    const isSelected = location.pathname.includes('/schedules');
    const { allRequestsCount, urgentRequestsCount } = useScheduleChangeRequestCounts();

    const displayBadge = allRequestsCount || urgentRequestsCount;
    const badgeColor = isSelected ? 'white' : urgentRequestsCount ? HIGH_PRIORITY_COLOR : AXLE_TEAL;

    return (
        <Badge
            variant='dot'
            invisible={!displayBadge}
            sx={{
                '& .MuiBadge-badge': {
                    backgroundColor: badgeColor,
                },
            }}
        >
            <Schedule ref={ref} {...props} />
        </Badge>
    );
});
